import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, Shield, Activity, Server } from 'lucide-react';
import { useAuthStore } from '../../app/store/auth-store';
import { useDashboardStats } from '../../shared/lib/hooks/use-dashboard-stats';
import { StatsCard, QuickActions, SystemInfo } from '../../widgets/dashboard';

export const DashboardPage: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuthStore();
  const { totalUsers, activeUsers, totalRoles, isLoading } = useDashboardStats();

  const displayName = user?.firstName 
    ? `${user.firstName}${user.lastName ? ` ${user.lastName}` : ''}`
    : user?.email;

  return (
    <div className="space-y-6">
      {/* Welcome Section */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">
          {t('dashboard.title')}
        </h1>
        <p className="text-muted-foreground">
          {t('dashboard.welcome')}, {displayName}!
        </p>
      </div>

      {/* Stats Cards */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatsCard
          title={t('dashboard.totalUsers')}
          value={totalUsers}
          description={t('dashboard.totalUsersDescription')}
          icon={<Users />}
          isLoading={isLoading}
        />
        
        <StatsCard
          title={t('dashboard.activeUsers')}
          value={activeUsers}
          description={t('dashboard.activeUsersDescription')}
          icon={<Activity />}
          isLoading={isLoading}
        />
        
        <StatsCard
          title={t('dashboard.totalRoles')}
          value={totalRoles}
          description={t('dashboard.totalRolesDescription')}
          icon={<Shield />}
          isLoading={isLoading}
        />
        
        <StatsCard
          title={t('dashboard.systemStatus')}
          value={t('dashboard.status.online')}
          description={t('dashboard.systemStatusDescription')}
          icon={<Server />}
          className="border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-950"
        />
      </div>

      {/* Quick Actions */}
      <QuickActions />

      {/* System Information */}
      <SystemInfo />
    </div>
  );
};